export default "__VITE_ASSET__CsqNT679__"